import dayjs from "dayjs";
import {EntityBase} from "../../shared/entity/EntityBase";

const CAMPAIGN_FIELDS = {
    id: { defaultValue: '' },
    recipientType: { type: Number, defaultValue: 0 },
    versionType: { type: Number, defaultValue: 0 },
    versions: { defaultValue: '' },
    items: { defaultValue: [] },
    title: { defaultValue: '' },
    validPeriod: { type: Number, defaultValue: 1 },
    memo: { defaultValue: '' },
    pIds: { defaultValue: '' },
    begin: { defaultValue: dayjs().startOf('day').unix() },
    end: { defaultValue: dayjs().endOf('day').unix() },
    registrationStart: { type: Number, defaultValue: 0 },
    registrationEnd: { type: Number, defaultValue: 4133948399 }, // 2100-12-31 23:59:59
    updated: { defaultValue: dayjs().format('YYYY-MM-DD HH:mm:ss') }
};

export class CampaignEntity extends EntityBase {
    constructor(data = {}) {
        super(data, CAMPAIGN_FIELDS);

        this.errors = [
            { condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.' },
            { condition: () => this.end < dayjs().unix(), message: '종료일이 현재 시간보다 이전입니다.' },
            { condition: () => this.title === 0, message: '캠페인 제목이 없습니다.' },
            { condition: () => this.items.length === 0, message: '아이템이 없습니다.' },
            { condition: () => this.versionType === 1 && this.versions === '', message: '대상 버전이 없습니다.' },
        ]
    }

    registrationReset() {
        this.registrationStart = 0;
        this.registrationEnd = 4133948399;
    }

    versionReset() {
        this.versionType = 0;
        this.versions = '';
    }
}